import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { sportCategories, getArticlesByCategory, getCategoryBySlug } from '@/mocks/sports';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? getCategoryBySlug(slug) : undefined;
  const articles = slug ? getArticlesByCategory(slug) : [];

  const [activeTab, setActiveTab] = useState<string>(slug || 'football');
  const activeCategory = getCategoryBySlug(activeTab);
  const activeArticles = getArticlesByCategory(activeTab);

  const handleTabChange = useCallback((newSlug: string) => {
    setActiveTab(newSlug);
    window.history.pushState(null, '', `/category/${newSlug}`);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <div className="pt-16 bg-background-100">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '体育分类' },
            ]}
          />
          <div className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8">
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  体育分类
                </h1>
                <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
                  浏览不同体育项目的赛事资讯和专业分析
                </p>
              </div>

              <div className="flex items-center justify-center mb-10">
                <div className="inline-flex flex-wrap justify-center gap-2 px-1 py-1 bg-background-200 rounded-full">
                  {sportCategories.map(cat => (
                    <button
                      key={cat.slug}
                      onClick={() => handleTabChange(cat.slug)}
                      className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer ${
                        activeTab === cat.slug
                          ? 'bg-primary-500 text-white'
                          : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-300'
                      }`}
                    >
                      {cat.name}
                    </button>
                  ))}
                </div>
              </div>

              {activeCategory && (
                <div className="mb-10 p-6 bg-background-50 rounded-2xl border border-background-200/70 text-center">
                  <div className="w-14 h-14 flex items-center justify-center mx-auto mb-3 rounded-xl bg-accent-100">
                    <i className={`${activeCategory.icon} text-2xl text-accent-600`}></i>
                  </div>
                  <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                    {activeCategory.name}
                  </h2>
                  <p className="text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                    {activeCategory.description}
                  </p>
                </div>
              )}

              {activeArticles.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {activeArticles.map(article => (
                    <Link
                      key={article.slug}
                      to={`/article/${article.slug}`}
                      className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer flex flex-col"
                    >
                      <div className="relative h-48 overflow-hidden">
                        <img
                          src={article.image}
                          alt={article.title}
                          title={article.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute top-3 left-3">
                          <span className="px-2.5 py-1 text-xs font-medium bg-background-50/90 backdrop-blur-sm text-primary-700 rounded-full">
                            {article.category}
                          </span>
                        </div>
                      </div>
                      <div className="p-5 flex flex-col flex-1">
                        <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-3">
                          {article.title}
                        </h3>
                        <p className="text-xs text-foreground-500 line-clamp-2 mb-4 leading-relaxed flex-1">
                          {article.excerpt}
                        </p>
                        <div className="flex items-center justify-between pt-3 border-t border-background-200">
                          <span className="text-xs text-foreground-400">{article.date}</span>
                          <span className="text-xs text-foreground-400">{article.readTime}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-200">
                    <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-500">暂无该分类的文章</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}